import type { SearchStatus } from './types';


export const RADAR_POLL_INTERVAL_MS = 2_500;
export const RADAR_POLL_TIMEOUT_MS = 16 * 60 * 1_000;

export function shouldContinueRadarPolling(
  status: SearchStatus,
  elapsedMs: number
): boolean {
  return (
    (status === 'queued' || status === 'processing')
    && elapsedMs < RADAR_POLL_TIMEOUT_MS
  );
}
